module.exports = __webpack_public_path__ + "media/assets/slide_icon-cedc2cfc3960f998a3d5442a003cbe5b9f7363d6ba63e36705b7de0ab6a154ee.png";